// extracted by mini-css-extract-plugin
export default {"melodyVideo":"lR-z","isFullWidth":"mR-z","landingPageVideo":"nR-z","play":"oR-z","iframeVideo":"pR-z","playHidden":"qR-z","fullwidth":"rR-z"};